import RoundedButton from 'components/RoundedButton';
import { ASSET_PREFIX, colors } from 'utils/constants';

interface IUnfavouritePrizeModalProps {
  prizeName: string;
  prizeHero: string;
  onConfirm: () => void;
  onClose: () => void;
}

const UnfavouritePrizeModal = ({
  prizeName,
  prizeHero,
  onConfirm,
  onClose,
}: IUnfavouritePrizeModalProps) => (
  <div
    className="container"
    id="dimmedBackground"
    onClick={(e) =>
      (e.target as HTMLElement).id === 'dimmedBackground' &&
      onClose &&
      onClose()
    }
  >
    <div id="message">
      {onClose && (
        <img
          id="closeButton"
          src={`${ASSET_PREFIX}/images/close_button_white.svg`}
          style={{ cursor: 'pointer', width: '20px' }}
          onClick={onClose}
          alt="close button - cross"
        />
      )}

      <div className="bodyContainer flexCentered">
        <h3>
          Are you <strong>Sure?</strong>
        </h3>

        <p>
          Are you sure you want to remove <strong>{prizeName}</strong> from your
          Wish List?
        </p>

        <RoundedButton
          onClick={onConfirm}
          style={{ margin: '1em', width: '100%', maxWidth: '220px' }}
        >
          Remove From List
        </RoundedButton>

        <a onClick={onClose} style={{ cursor: 'pointer' }}>
          Cancel
        </a>
      </div>
    </div>

    <style jsx>{`
      .container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        max-width: 100%;
        height: 100%;
        background-color: rgba(55, 55, 55, 0.8);
        z-index: 999;
      }

      #message {
        position: relative;
        background-color: white;
        background: url(${prizeHero});
        background-size: cover;
        background-position: bottom;
        color: ${colors.primaryBrandGray};
        top: 50%;
        left: 50%;
        width: 90%;
        max-width: 500px;
        max-height: 95%;
        overflow-y: auto;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);

        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 7px;
        box-shadow: 0 0 15px #333;
        z-index: 1000;
        text-align: center;
      }

      #closeButton {
        position: fixed;
        width: 20px;
        height: 20px;
        right: 16px;
        top: 16px;
      }

      .bodyContainer {
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 35%
        );
        width: 100%;
        margin-top: 12em;
        padding: 5em 3em 3em;
      }
    `}</style>
  </div>
);

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

/** Wraps a component in a higher-order component that ensures that the component gets rendered into a React Portal at
 * the bottom of the DOM.
 *
 * This is useful to ensure a component appears outside of some other component, e.g. when the component uses
 * position:fixed, but the component's ancestors use transform: translate, which messages up position fixed
 *
 * @deprecated Probably not needed - can likely just use createPortal in the WrappedComponent's render function, rather
 * than having to create another element
 */
function withPortal<T extends React.ComponentType<any>>(
  WrappedComponent: T,
  portalId: string = 'portal-root',
): React.FC<React.ComponentProps<T>> {
  const PortalWrapper: React.FC<React.ComponentProps<T>> = (props) => {
    const [portalElement, setPortalElement] = useState<HTMLElement | null>(
      null,
    );

    useEffect(() => {
      let element = document.getElementById(portalId);

      if (!element) {
        element = document.createElement('div');
        element.id = portalId;
        document.body.appendChild(element);
      }

      setPortalElement(element);

      return () => {
        if (element?.parentNode) {
          element.parentNode.removeChild(element);
        }
      };
    }, [portalId]);

    if (!portalElement) return null;

    return ReactDOM.createPortal(
      <WrappedComponent {...props} />,
      portalElement,
    );
  };

  return PortalWrapper;
}

export default withPortal(UnfavouritePrizeModal);
